import { z } from 'zod'

export const ErrorData = z.object({
  type: z.enum(['error', 'success', 'warning', 'info']),
  title: z.string(),
  message: z.string()
})

export type ErrorData = z.infer<typeof ErrorData>
